export default "__VITE_ASSET__37df9e07__"